import { getRequest, postRequest, postRequestFormData, postRequestFormDataWithImage, postrequestFormDataForImage, putRequest } from "../config/helper";

import { API_BASE_URL } from '../config/apiConfig';
import axios from 'axios';
import { apiConstants } from '../constants/api.constant';
import config from '../config/config';

// ============================================================================
// AUTHENTICATION ENDPOINTS
// ============================================================================

export const loginAction = (data) => {
   return postRequest('auth/login', data).then(res => { return res.data })
}
export const smsVerificationAction = (data) => {
   return postRequest('auth/sms-verification', data).then(res => { return res.data })
}
export const forgotPasswordAction = (data) => {
   return postRequest('auth/forgot-password', data).then(res => { return res.data })
}
export const verifyForgetPasswordOTPAction = (data) => {
   return postRequest('auth/verify-forgot-password-otp', data).then(res => { return res.data })
}
export const resetpasswordAction = (data) => {
   return postRequest('auth/reset-password', data).then(res => { return res.data })
}

// ============================================================================
// STAFF MANAGEMENT ENDPOINTS (Updated for FastAPI compatibility)
// ============================================================================

export const getStaffListAction = (data) => {
   // Transform legacy parameters to match backend expectations
   const params = {
      page: data.page || 1,
      page_size: data.page_size || 20,
      search: data.name || data.search,
      is_active: data.status === 'active' ? true :
         data.status === 'inactive' ? false : null
   };

   return getRequest('users', params).then(res => {
      // Backend returns UserListResponse with users array
      return {
         success: true,
         data: res.users || [],
         total: res.total_count || 0,
         msg: "Staff list retrieved successfully"
      };
   }).catch(error => {
      console.error('Error fetching staff list:', error);
      return {
         success: false,
         data: [],
         total: 0,
         msg: error.response?.data?.detail || "Failed to fetch staff list"
      };
   });
}

export const getAllPatientsCredentialsAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('patients/getAllPatientsCredentials', sanitizedData).then(res => { return res.data })
}

// User Group Management Endpoints
export const getGroupTypesAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('rbac/roles', sanitizedData).then(res => {
      // Backend returns RoleListResponse with roles array
      return {
         success: true,
         data: res.roles || [],
         total: res.total_count || 0,
         message: "Roles retrieved successfully"
      };
   }).catch(error => {
      console.error('Error fetching roles:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch roles"
      };
   });
}

export const addStaffAction = (data) => {
   return postRequestFormData('users', data).then(res => { return res.data })
}

export const addPatientAction = (data) => {
   return postRequest('patients/pre-register', data).then(res => { return res.data })
}

export const updateFcmTokenAction = (data) => {
   return postRequestFormData('users/update-fcm-token', data).then(res => { return res.data })
}

export const updateStaffAction = (data) => {
   // Use PUT for updating users
   const userId = data.id || data.userId;
   return putRequest(`users/${userId}`, data).then(res => { return res.data })
}

export const updatePatientCredentialsAction = (data) => {
   return postRequestFormData('patients/updatePatientCredentials', data).then(res => { return res.data })
}

export const changePasswordAction = (data) => {
   // Transform frontend field names to backend expected names
   const transformedData = {
      current_password: data.oldPassword,
      new_password: data.newPassword,
      confirm_password: data.confirmPassword || data.newPassword // Fallback to newPassword if confirmPassword not provided
   };
   return postRequest('auth/change-password', transformedData).then(res => { return res.data })
}

export const getStaffDetailsAction = (data) => {
   // Handle both object and direct ID parameter
   const userId = typeof data === 'object' ? (data.id || data.userId) : data;

   // Don't pass data as parameters for GET request - just use the userId in the URL
   return getRequest(`users/${userId}`, null).then(res => { return res.data })
}

export const getBulkStaffDetailsAction = (userIds) => {
   // Use the new optimized bulk endpoint for multiple users
   return postRequest('users/bulk', userIds).then(res => { return res.data })
}

export const getpatientDetailsbyIdAction = (data) => {
   return postRequestFormData('patients/getPatientDetailById', data).then(res => { return res.data })
}

// User Group Management Endpoints
export const getUserGroupListAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('rbac/roles', sanitizedData).then(res => {
      // Backend returns RoleListResponse with roles array
      return {
         success: true,
         data: res.roles || [],
         total: res.total_count || 0,
         message: "Roles retrieved successfully"
      };
   }).catch(error => {
      console.error('Error fetching roles:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch roles"
      };
   });
}

export const addUserGroupAction = (data) => {
   return postRequest('rbac/addUserGroup', data).then(res => { return res.data })
}

export const getGroupDetailsAction = (data) => {
   return postRequest('rbac/getUserGroupById', data).then(res => { return res.data })
}

export const updateUserGroupAction = (data) => {
   return postRequest('rbac/updateUserGroup', data).then(res => { return res.data })
}

// ============================================================================
// MODERN DYNAMIC FORMS ENDPOINTS (Updated to use modern backend architecture)
// ============================================================================

// Department Management (Modern)
export const getDepartmentsAction = (params = {}) => {
   return getRequest('dynamic-forms/departments', params).then(res => {
      // Transform modern response to legacy format for compatibility
      return {
         success: true,
         data: res.items || [],
         total: res.total || 0,
         message: "Departments fetched successfully"
      }
   }).catch(error => {
      console.error('Error fetching departments:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch departments"
      };
   });
}

export const getDepartmentByIdAction = (departmentId) => {
   return getRequest(`dynamic-forms/departments/${departmentId}`).then(res => {
      return {
         success: true,
         data: res,
         message: "Department fetched successfully"
      }
   })
}

export const addDepartmentAction = (data) => {
   return postRequest('dynamic-forms/departments', data).then(res => {
      return {
         success: true,
         data: res,
         message: "Department created successfully"
      }
   })
}

export const updateDepartmentAction = (departmentId, data) => {
   return putRequest(`dynamic-forms/departments/${departmentId}`, data).then(res => {
      return {
         success: true,
         data: res,
         message: "Department updated successfully"
      }
   })
}

export const deleteDepartmentAction = (departmentId) => {
   return postRequest(`dynamic-forms/departments/${departmentId}`, {}, 'DELETE').then(res => {
      return {
         success: true,
         data: res,
         message: "Department deleted successfully"
      }
   })
}

// Category Management (Modern)
export const getCategoriesAction = (params = {}) => {
   return getRequest('dynamic-forms/categories', params).then(res => {
      return {
         success: true,
         data: res.items || [],
         total: res.total || 0,
         message: "Categories fetched successfully"
      }
   })
}

export const getCategoryByIdAction = (categoryId) => {
   return getRequest(`dynamic-forms/categories/${categoryId}`).then(res => {
      return {
         success: true,
         data: res,
         message: "Category fetched successfully"
      }
   })
}

export const addCategoryAction = (data) => {
   return postRequest('dynamic-forms/categories', data).then(res => {
      return {
         success: true,
         data: res,
         message: "Category created successfully"
      }
   })
}

export const updateCategoryAction = (categoryId, data) => {
   return putRequest(`dynamic-forms/categories/${categoryId}`, data).then(res => {
      return {
         success: true,
         data: res,
         message: "Category updated successfully"
      }
   })
}

export const deleteCategoryAction = (categoryId) => {
   return postRequest(`dynamic-forms/categories/${categoryId}`, {}, 'DELETE').then(res => {
      return {
         success: true,
         data: res,
         message: "Category deleted successfully"
      }
   })
}

// Form Management (Modern)
export const getFormsAction = (params = {}) => {
   return getRequest('dynamic-forms/forms', params).then(res => {
      return {
         success: true,
         data: res.items || [],
         total: res.total || 0,
         message: "Forms fetched successfully"
      }
   }).catch(error => {
      console.error('Error fetching forms:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch forms"
      };
   });
}

export const getFormByIdAction = (formId) => {
   return getRequest(`dynamic-forms/forms/${formId}`).then(res => {
      return {
         success: true,
         data: res,
         message: "Form fetched successfully"
      }
   })
}

export const addFormAction = (data) => {
   return postRequest('dynamic-forms/forms', data).then(res => {
      return {
         success: true,
         data: res,
         message: "Form created successfully"
      }
   })
}

export const updateFormAction = (formId, data) => {
   return putRequest(`dynamic-forms/forms/${formId}`, data).then(res => {
      return {
         success: true,
         data: res,
         message: "Form updated successfully"
      }
   })
}

export const deleteFormAction = (formId) => {
   return postRequest(`dynamic-forms/forms/${formId}`, {}, 'DELETE').then(res => {
      return {
         success: true,
         data: res,
         message: "Form deleted successfully"
      }
   })
}

export const submitFormAction = (formId, data) => {
   return postRequest(`dynamic-forms/forms/${formId}/submit`, data).then(res => {
      return {
         success: true,
         data: res,
         message: "Form submitted successfully"
      }
   })
}

export const validateFormAction = (formId, data) => {
   return postRequest(`dynamic-forms/forms/${formId}/validate`, data).then(res => {
      return {
         success: true,
         data: res,
         message: "Form validation completed"
      }
   })
}

// Form Submissions (Modern)
export const getSubmissionsAction = (params = {}) => {
   return getRequest('dynamic-forms/submissions', params).then(res => {
      return {
         success: true,
         data: {
            submissions: res.items || [],
            total: res.total || 0,
            skip: res.skip || 0,
            limit: res.limit || 50,
            has_more: res.has_more || false
         },
         message: "Submissions fetched successfully"
      }
   })
}

export const getSubmissionByIdAction = (submissionId) => {
   return getRequest(`dynamic-forms/submissions/${submissionId}`).then(res => {
      return {
         success: true,
         data: res.data,
         message: "Submission fetched successfully"
      }
   })
}

// Analytics (Modern)
export const getSubmissionStatsAction = (params = {}) => {
   return getRequest('dynamic-forms/analytics/submission-stats', params).then(res => {
      return {
         success: true,
         data: res,
         message: "Statistics fetched successfully"
      }
   })
}

export const getFormSubmissionCountsAction = (params = {}) => {
   return getRequest('dynamic-forms/analytics/form-submission-counts', params).then(res => {
      return {
         success: true,
         data: res,
         message: "Form submission counts fetched successfully"
      }
   })
}

export const getMonthlyStatsAction = (params = {}) => {
   return getRequest('dynamic-forms/analytics/monthly-stats', params).then(res => {
      return {
         success: true,
         data: res,
         message: "Monthly statistics fetched successfully"
      }
   })
}

export const getPatientSubmissionSummaryAction = (patientId, params = {}) => {
   return getRequest(`dynamic-forms/analytics/patient/${patientId}/submissions`, params).then(res => {
      return {
         success: true,
         data: res,
         message: "Patient submission summary fetched successfully"
      }
   })
}

// ============================================================================
// LEGACY ENDPOINTS (Kept for backward compatibility during transition)
// ============================================================================

// Form Permission Management Endpoints (Legacy)
export const updateFormsPermissionAction = (data) => {
   return postRequest('dynamic-forms/updateFormsPermission', data).then(res => { return res.data })
}

export const getGroupListWithPermissionAction = (data) => {
   return postRequest('rbac/getGroupListWithPermission', data).then(res => { return res.data })
}

export const updateGroupsPermissionAction = (data) => {
   return postRequest('rbac/updateGroupsPermission', data).then(res => { return res.data })
}

// Form Data Management Endpoints (Legacy)
export const insertFormDataAction = (data) => {
   return postrequestFormDataForImage('dynamic-forms/forms/submit', data).then(res => { return res.data })
}

export const updateAddendumStatusAction = (data) => {
   return putRequest('dynamic-forms/submissions/update-addendum-status', data).then(res => { return res.data })
}

export const reAdmitDataAction = (data) => {
   return postrequestFormDataForImage('dynamic-forms/forms/re-admit', data).then(res => { return res.data })
}

// Medication Management Endpoints
export const initiateDrugAction = (data) => {
   return postRequest('medications/prescriptions/initiate', data).then(res => res.data);
};

export const recordDrugAction = (data) => {
   return putRequest('medications/prescriptions/record', data).then(res => res.data);
};

export const getDrugHistoryAction = (data) => {
   return postRequest('medications/prescriptions/history', data).then(res => res.data);
};

export const getInitiateRecordStatusAction = (prescription_id) => {
   return getRequest(`medications/prescriptions/${prescription_id}/status`).then(res => res.data);
};

export const insertRxDataAction = (data) => {
   return postrequestFormDataForImage('medications/prescriptions/rx-data', data).then(res => { return res.data })
}

export const insertFormDataActionForSubForm = (data) => {
   return postRequest('dynamic-forms/submissions/update-sub-form', data).then(res => { return res.data })
}

// Patient Data Management Endpoints
export const getPatientDataAction = async (data) => {
   // Import modern service at runtime to avoid circular dependency
   const patientService = (await import('../services/patientService')).default;

   // If we have a patientId, use the get-by-id endpoint
   if (data.patientId) {
      try {
         const result = await patientService.getPatientById(data.patientId);
         return { success: true, data: result };
      } catch (error) {
         console.error('Error getting patient by ID:', error);
         return { success: false, data: { message: error.message } };
      }
   }

   // Otherwise, use search endpoint with proper parameters
   const searchParams = {
      query: data.search || data.name || data.patient_name,
      mrn: data.mrn,
      emirates_id: data.emirates_id,
      phone: data.phone,
      email: data.email,
      limit: data.limit || 50,
      offset: data.offset || 0
   };

   // Remove empty parameters
   Object.keys(searchParams).forEach(key => {
      if (!searchParams[key] && searchParams[key] !== 0) {
         delete searchParams[key];
      }
   });

   // Ensure we have a valid search query (minimum 2 characters)
   if (!searchParams.query || searchParams.query.length < 2) {
      return { 
         success: false, 
         data: { message: 'Search query must be at least 2 characters long' } 
      };
   }

   try {
      const result = await patientService.searchPatients(searchParams);
      return { success: true, data: result };
   } catch (error) {
      console.error('Error searching patients:', error);
      return { success: false, data: { message: error.message } };
   }
}

export const getPatientDataByMRNAction = (data) => {
   return postRequest('patients/getPatientDataByMrn', data).then(res => { return res.data })
}

// Web Form Management Endpoints (Legacy)
export const saveWebFormAction = (data) => {
   return postRequest('dynamic-forms/forms', data).then(res => { return res.data })
}

export const getFormListAction = (data) => {
   return getRequest('dynamic-forms/forms', data).then(res => { return res.data })
}

export const getFormListForStaffAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dynamic-forms/forms', sanitizedData).then(res => { return res.data })
}

export const getFormListForMenuAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dynamic-forms/forms', sanitizedData).then(res => { return res.data })
}

export const getFormDetailsAction = (formId) => {
   // Validate formId
   if (!formId || formId === 'undefined' || formId === 'null') {
      console.error('❌ Invalid formId provided to getFormDetailsAction:', formId);
      return Promise.resolve({
         success: false,
         data: null,
         message: "Invalid form ID provided"
      });
   }

   console.log('🔍 Constructing URL for form details:', `dynamic-forms/forms/${formId}`);
   return getRequest(`dynamic-forms/forms/${formId}`).then(res => {
      return {
         success: true,
         data: res,
         message: "Form details retrieved successfully"
      };
   }).catch(error => {
      console.error('Error fetching form details:', error);
      return {
         success: false,
         data: null,
         message: error.response?.data?.detail || "Failed to fetch form details"
      };
   });
}

// Medication Prescription Endpoints
export const getMedpassPrescriptionListAction = (data) => {
   return postRequest('medications/getMedpassPrescriptionList', data).then(res => { return res.data })
}

export const getPrescriptionAssignListAction = (data) => {
   return postRequest('medications/prescriptions/assign-list', data).then(res => { return res.data })
}

export const updateRxStatusAction = (data) => {
   return postRequest('medications/prescriptions/update-status', data).then(res => { return res.data })
}

// Form Fields and Categories Endpoints (Legacy)
export const getFormFieldsDataAction = (data) => {
   return getRequest('dynamic-forms/field-types', data).then(res => { return res.data })
}

export const getFieldTypeAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dynamic-forms/field-types', sanitizedData).then(res => {
      // Backend returns list of field types
      return {
         success: true,
         data: res || [],
         message: "Field types retrieved successfully"
      };
   }).catch(error => {
      console.error('Error fetching field types:', error);
      return {
         success: false,
         data: [],
         message: error.response?.data?.detail || "Failed to fetch field types"
      };
   });
}

// Department Management Endpoints (Legacy)
export const getDepartmentAction = (data) => {
   return getRequest('dynamic-forms/departments', data).then(res => {
      // Transform modern response to legacy format for compatibility
      return {
         success: true,
         data: res.items || [],
         total: res.total || 0,
         message: "Departments fetched successfully"
      }
   }).catch(error => {
      console.error('Error fetching departments:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch departments"
      };
   });
}

export const getCategoryListAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dynamic-forms/categories', sanitizedData).then(res => {
      // Transform modern response to legacy format for compatibility
      return {
         success: true,
         data: res.items || [],
         total: res.total || 0,
         message: "Categories fetched successfully"
      }
   }).catch(error => {
      console.error('Error fetching categories:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch categories"
      };
   });
}

export const getCategoryListForWebFormAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dynamic-forms/categories', sanitizedData).then(res => {
      // Transform modern response to legacy format for compatibility
      return {
         success: true,
         data: res.items || [],
         total: res.total || 0,
         message: "Categories fetched successfully"
      }
   }).catch(error => {
      console.error('Error fetching categories:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch categories"
      };
   });
}

export const getDepartmentMenuesAction = (data) => {
   return getRequest('dynamic-forms/getDepartmentMenues', data).then(res => { return res.data })
}

export const getDepartmentFormsAction = (data) => {
   return postRequest('dynamic-forms/getDepartmentFormsList', data).then(res => { return res.data })
}

export const getDepartmentFormsTypeAction = (data) => {
   return postRequest('dynamic-forms/departments/forms-type', data).then(res => { return res.data })
}

// Category Management Endpoints (Legacy)
// export const getFormCategoryAction = (data) => {
//    return getRequest('dynamic-forms/categories', data).then(res => {
//       // Transform modern response to legacy format for compatibility
//       console.log("lol", res)
//       return {
//          success: true,
//          data: res.data.items || [],
//          total: res.data.total || 0,
//          message: "Categories fetched successfully"
//       }
//    }).catch(error => {
//       console.error('Error fetching categories:', error);
//       return {
//          success: false,
//          data: [],
//          total: 0,
//          message: error.response?.data?.detail || "Failed to fetch categories"
//       };
//    });
// }
export const getFormCategoryAction = (data) => {
   return getRequest('dynamic-forms/categories', data).then(res => {
      console.log("lol", res);

      const allItems = res.data.items || [];

      // Filter based on category_id if provided
      const filteredItems = data?.id
         ? allItems.filter(item => item.category_id === data.id)
         : allItems;

      return {
         success: true,
         data: filteredItems,
         total: filteredItems.length,
         message: "Categories fetched successfully"
      };
   }).catch(error => {
      console.error('Error fetching categories:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch categories"
      };
   });
};


export const getFormTypeListAction = (data) => {
   // Transform to modern form types endpoint
   const params = data && data.department_id ? { department_id: data.department_id } : {};

   return getRequest('dynamic-forms/form-types', params).then(res => {
      // Backend returns list of form types
      return {
         success: true,
         data: res || [],
         message: "Form types retrieved successfully"
      };
   }).catch(error => {
      console.error('Error fetching form types:', error);
      return {
         success: false,
         data: [],
         message: error.response?.data?.detail || "Failed to fetch form types"
      };
   });
}

// Form Data List Endpoints
export const getFormDataListAction = (data) => {
   return postRequest('dynamic-forms/submissions', data).then(res => { return res.data })
}

export const getPivotedFormDataAction = (data) => {
   return postRequest('dynamic-forms/submissions/pivoted', data).then(res => { return res.data })
}

// Role Management Endpoints
export const getAllRolesApi = () => {
   return getRequest('rbac/get-all-roles-with-permission').then(res => { return res.data })
}

// ============================================================================
// PATIENT STATUS ENDPOINTS
// ============================================================================

export const currentStatusAPI = () => {
   return getRequest('patients/currentStatus').then(res => { return res.data })
}

export const currentLocationStatus = () => {
   return getRequest('patients/currentLocationStatus').then(res => { return res.data })
}

// ============================================================================
// REPORTING & ANALYTICS ENDPOINTS
// ============================================================================

// Prescription Management Endpoints
export const getPrescriptionListAction = (data) => {
   return postRequest('medications/prescriptions/list', data).then(res => { return res.data })
}

export const getPatientDetailsAction = (data) => {
   return postRequest('patients/getPatientDetails', data).then(res => { return res.data })
}

export const getFormDataListByStaffAction = (data) => {
   return postRequest('dynamic-forms/submissions/by-staff', data).then(res => { return res.data })
}

export const getPatientListAction = (data) => {
   return postRequest('patients/', data).then(res => { return res.data })
}

// Staff Activity Endpoints
export const getStaffActivityLogsListAction = (data) => {
   // TODO: This endpoint doesn't exist in the modern backend yet
   // For now, return empty data to prevent errors
   return Promise.resolve({
      success: true,
      data: [],
      message: "Activity logs not available in modern API"
   });
}

export const assignPatientAction = (data) => {
   return postRequest('patients/assign-patient', data).then(res => { return res.data })
}

export const getAssignedPatientListAction = (data) => {
   return postRequest('patients/assigned-patients', data).then(res => { return res.data })
}

export const updateStaffStatusAction = (data) => {
   // Use PUT endpoint for updating user status
   const endpoint = `users/${data.id}`;
   const updateData = {
      is_active: data.status === 1
   };

   return putRequest(endpoint, updateData).then(res => { return res.data });
}

// Dashboard and Statistics Endpoints
export const getUpcomingEventAction = (data) => {
   return postRequest('scheduling/upcoming-events', data).then(res => { return res.data })
}

export const getPatientRecordDashboardAction = (data) => {
   return postRequest('patients/getPatientRecordDashboard', data).then(res => { return res.data })
}

export const getFormDataListDetailByIdAction = (data) => {
   return postRequest('dynamic-forms/submissions/detail-by-id', data).then(res => { return res.data })
}

export const getDashboardStatisticsAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dashboard/statistics', sanitizedData).then(res => { return res.data })
}

// Web Form Management Endpoints
export const updateWebFormAction = (data) => {
   return postRequest('dynamic-forms/forms/update', data).then(res => { return res.data })
}

export const addWebFormFieldsAction = (data) => {
   return postRequest('dynamic-forms/forms/add-fields', data).then(res => { return res.data })
}

export const deleteWebFormFieldAction = (data) => {
   return postRequest('dynamic-forms/forms/delete-field', data).then(res => { return res.data })
}

export const deleteWebFormAction = (data) => {
   return postRequest('dynamic-forms/forms/delete', data).then(res => { return res.data })
}

// Department Management Endpoints
export const getDepartmentListAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dynamic-forms/departments', sanitizedData).then(res => { return res.data })
}

export const submitWebFormActionData = (data) => {
   return postRequest('dynamic-forms/forms/submit-web-form', data).then(res => { return res.data })
}

export const getDepartmentDetailsAction = (departmentId) => {
   return getRequest(`dynamic-forms/departments/${departmentId}`).then(res => {
      return {
         success: true,
         data: res,
         message: "Department details retrieved successfully"
      }
   }).catch(error => {
      console.error('Error fetching department details:', error);
      return {
         success: false,
         data: null,
         message: error.response?.data?.detail || "Failed to fetch department details"
      };
   });
}

export const getDepartmentFormsListAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('dynamic-forms/forms', sanitizedData).then(res => {
      // Transform modern response to legacy format for compatibility
      return {
         success: true,
         data: res.items || [],
         total: res.total || 0,
         message: "Department forms fetched successfully"
      }
   }).catch(error => {
      console.error('Error fetching department forms:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch department forms"
      };
   });
}

export const addDepartmentFormsAction = (data) => {
   return postRequest('dynamic-forms/addDepartmentForms', data).then(res => { return res.data })
}

export const getDepartmentFormDetailsAction = (data) => {
   return postRequest('dynamic-forms/getDepartmentFormDetails', data).then(res => { return res.data })
}

export const updateDepartmentFormAction = (data) => {
   return postRequest('dynamic-forms/updateDepartmentForm', data).then(res => { return res.data })
}

// Master Data Management Endpoints
export const getCPTMasterListAction = (data) => {
   return getRequest('master-data/cpt-master', data).then(res => { return res.data })
}

export const addCPTMasterAction = (data) => {
   return postRequest('master-data/cpt-master', data).then(res => { return res.data })
}

export const deleteCPTMasterDataAction = (data) => {
   return postRequest('master-data/cpt-master/delete', data).then(res => { return res.data })
}

export const getDrugMasterListAction = (data) => {
   return getRequest('master-data/drug-master', data).then(res => { return res.data })
}

export const getHCPCSMasterListAction = (data) => {
   return getRequest('master-data/hcpcs-master', data).then(res => { return res.data })
}

export const addHPCSMasterAction = (data) => {
   return postRequest('master-data/hcpcs-master', data).then(res => { return res.data })
}

export const deleteHPCSMasterDataAction = (data) => {
   return postRequest('master-data/hcpcs-master/delete', data).then(res => { return res.data })
}

export const getICDMasterListAction = (data) => {
   return getRequest('master-data/icd10-master', data).then(res => { return res.data })
}

export const addICDMasterAction = (data) => {
   return postRequest('master-data/icd10-master', data).then(res => { return res.data })
}

export const deleteICDMasterDataAction = (data) => {
   return postRequest('master-data/icd10-master/delete', data).then(res => { return res.data })
}

export const getMasterListAction = (data) => {
   // Ensure data is properly sanitized for GET request
   const sanitizedData = data && typeof data === 'object' ?
      Object.fromEntries(
         Object.entries(data).filter(([_, value]) =>
            value !== null && value !== undefined && value !== ''
         )
      ) : {};

   return getRequest('master-data/tables', sanitizedData).then(res => {
      // Backend returns MasterDataTableListResponse with tables array
      return {
         success: true,
         data: res.tables || [],
         total: res.total || 0,
         message: "Master data list retrieved successfully"
      };
   }).catch(error => {
      console.error('Error fetching master data:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch master data"
      };
   });
}

export const saveMasterDataAction = (data) => {
   return postRequest('master-data/save', data).then(res => { return res.data })
}

export const getMasterTableDataAction = (data) => {
   return postRequest('master-data/tables', data).then(res => { return res.data })
}

export const getSingleMasterTableDataAction = (data) => {
   return getRequest(`master-data/tables/${data}`).then(res => { return res.data })
}

export const deleteMasterDataAction = (data) => {
   return postRequest('master-data/delete', data).then(res => { return res.data })
}

export const deleteMasterColumnAction = (data) => {
   return postRequest('master-data/delete-column', data).then(res => { return res.data })
}

export const updateMasterTableAction = (data) => {
   return postRequest('master-data/update-table', data).then(res => { return res.data })
}

export const updateMasterTableFieldsAction = (id, data) => {
   return putRequest(`master-data/tables/${id}`, data).then(res => { return res.data })
}

export const importExcelFileAction = (data) => {
   return postRequestFormData('master-data/import-excel', data).then(res => { return res.data })
}

export const getMasterDataDetailsAction = (data) => {
   return getRequest('master-data/details', data).then(res => { return res.data })
}

export const getMasterlistDetailByNameAction = (data) => {
   return postRequest('master-data/detail-by-name', data).then(res => { return res.data })
}

export const getMasterTableColumnAction = async (data) => {
   // Import modern service at runtime to avoid circular dependency
   const masterDataService = (await import('../services/masterDataService')).default;

   try {
      // Use modern service to get master data by name
      const tableName = data.name || data.table_name;
      if (tableName) {
         const result = await masterDataService.searchMasterData({ name: tableName });
         return result;
      } else {
         const result = await masterDataService.getMasterData(data);
         return result;
      }
   } catch (error) {
      console.error('Error fetching master table columns:', error);
      return {
         success: false,
         data: [],
         total: 0,
         message: error.response?.data?.detail || "Failed to fetch master data tables"
      };
   }
}

export const addMasterDataDetailsAction = (data) => {
   return postRequest('master-data/add-details', data).then(res => { return res.data })
}

export const deleteTableDataAction = (data) => {
   return postRequest('master-data/delete-table-data', data).then(res => { return res.data })
}

export const getTableContentdetailByIdAction = (data) => {
   return postRequest('master-data/table-content-by-id', data).then(res => { return res.data })
}

export const updateTableContentDetailsByIdAction = (data) => {
   return postRequest('master-data/update-table-content', data).then(res => { return res.data })
}

export const hendleSearchPatientAction = (data) => {
   return postRequest('patients/search', data).then(res => { return res.data })
}

export const getpatientDetailsById = (data) => {
   return postRequest('patients/getPatientDetailsById', data).then(res => { return res.data })
}

// Appointment Management Endpoints
export const getDoctorList = (data) => {
   return postRequest('scheduling/doctors', data).then(res => { return res.data })
}

export const addDoctorAppointment = (data) => {
   return postRequest('scheduling/appointments', data).then(res => { return res.data })
}

export const getAppointmentList = (data) => {
   return postRequest('scheduling/appointments/list', data).then(res => { return res.data })
}

export const getAppointmentsByDocId = (data) => {
   return postRequest('scheduling/appointments/by-doctor', data).then(res => { return res.data })
}

export const updateAppointmentsById = (data) => {
   return postRequest('scheduling/appointments/update', data).then(res => { return res.data })
}

export const deleteAppointmentsById = (data) => {
   return postRequest('scheduling/appointments/delete', data).then(res => { return res.data })
}

export const patientStatusUpdateByIdAction = (data) => {
   return postRequest('patients/update-status', data).then(res => { return res.data })
}

export const getPatiantUniqueIDAndMrnNumByIDAction = (data) => {
   return postRequest('patients/unique-id-mrn', data).then(res => { return res.data })
}

export const getpatientFormDetailsById = (data) => {
   return postRequest('dynamic-forms/patient-form-details', data).then(res => { return res.data })
}

export const getDraftDataAction = async (data) => {
   // Import modern service at runtime to avoid circular dependency
   const dynamicFormsService = (await import('../services/dynamicFormsService')).default;

   // Use modern endpoint with draft status filter
   const formId = data.form_id || data.formId;
   const params = { status: 'draft', ...data };

   try {
      const result = await dynamicFormsService.getFormSubmissions(formId, params);
      return { data: result };
   } catch (error) {
      console.error('Error fetching draft data:', error);
      return { data: { success: false, message: error.message } };
   }
}

export const getLatestDraftAction = async (formId, patientId) => {
   try {
      // Get auth token from localStorage
      let authToken = null;
      try {
         const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
         if (storageData) {
            const loginData = JSON.parse(storageData);
            authToken = loginData.authToken;
         }
      } catch (error) {
         console.error('Error parsing login data:', error);
      }

      const response = await fetch(`${config.serverPath}/dynamic-forms/forms/${formId}/latest-draft/${patientId}`, {
         method: 'GET',
         headers: {
            'Content-Type': 'application/json',
            'Authorization': authToken ? `Bearer ${authToken}` : ''
         }
      });
      
      if (!response.ok) {
         if (response.status === 404) {
            // No draft found, return null
            return { success: true, data: null };
         }
         throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      return { success: true, data: result };
   } catch (error) {
      return { success: false, data: null, message: error.message };
   }
}

export const getSubmissionHistoryAction = async (formId, patientId, paginationParams = {}) => {
   try {
      console.log(`🚀 getSubmissionHistoryAction called with formId: ${formId}, patientId: ${patientId}`, paginationParams);
      
      // Get auth token from localStorage
      let authToken = null;
      try {
         const storageData = localStorage.getItem('loginSuccessNeurulaHealth');
         if (storageData) {
            const loginData = JSON.parse(storageData);
            authToken = loginData.authToken;
         }
      } catch (error) {
         console.error('Error parsing login data:', error);
      }

      // Build query parameters for pagination
      const { limit = 50, cursor, sortBy = 'submitted_at', sortOrder = 'desc' } = paginationParams;
      const queryParams = new URLSearchParams({
         limit: limit.toString(),
         sort_by: sortBy,
         sort_order: sortOrder,
         form_id: formId  // Add the form_id parameter
      });
      
      if (cursor) {
         queryParams.append('cursor', cursor);
      }

      const url = `${config.serverPath}/dynamic-forms/patients/${patientId}/submissions?${queryParams}`;
      console.log(`🌐 Making request to: ${url}`);
      console.log(`🔍 Query parameters:`, Object.fromEntries(queryParams.entries()));

      const response = await fetch(url, {
         method: 'GET',
         headers: {
            'Content-Type': 'application/json',
            'Authorization': authToken ? `Bearer ${authToken}` : ''
         }
      });
      
      console.log(`📡 Response status: ${response.status}`);
      
      if (!response.ok) {
         const errorText = await response.text();
         console.error(`❌ HTTP error: ${response.status}, response: ${errorText}`);
         throw new Error(`HTTP error! status: ${response.status}, response: ${errorText}`);
      }
      
      const result = await response.json();
      console.log(`✅ Response data:`, result);
      return { success: true, data: result };
   } catch (error) {
      console.error(`❌ getSubmissionHistoryAction error:`, error);
      return { success: false, data: null, message: error.message };
   }
}

export const getStaffDutyAction = (data) => {
   return postRequest('scheduling/staff-duty', data).then(res => { return res.data })
}

export const getFormDataByMasterAction = (data) => {
   return postRequest('dynamic-forms/form-data-by-master', data).then(res => { return res.data })
}

export const updateRecordStatus = (data) => {
   return postRequest('dynamic-forms/update-record-status', data).then(res => { return res.data })
}

export const getAllReportContentAction = (data) => {
   return postRequest('reports/all-content', data).then(res => { return res.data })
}

export const updateReportContent = (data) => {
   return postRequest('reports/update-content', data).then(res => { return res.data })
}

export const getPatiendInfoAction = (data) => {
   return postRequest('patients/patient-info', data).then(res => { return res.data })
}